<template>
  <div class="marginBT p-grid">
    <div class="p-lg-2 p-sm-12" />
    <div class="p-lg-8 p-sm-12">
      <div class="marginLR center">
        <h2 class="titles">
          {{ $t("consultaFichero.formularioTituloPropios") }}
        </h2>
        <p class="subtitles">
          {{ $t("consultaFichero.formularioSubtituloPropios") }}
        </p>
      </div>
      <div class="whitePanel marginBottom">
        <div class="p-grid">
          <div>
            <p class="blueText">
              <i class="pi pi-info" />{{
                $t("consultaFichero.textos.propiosCabecera")
              }}<br /><br />{{ $t("consultaFichero.textos.propiosCabecera2") }}
            </p>
          </div>
          <div class="p-col-12">
            {{ $t("consultaFichero.textos.propiosTexto") }}
          </div>
          <div class="p-col-12">
            <Button
              @click="downloadPDF()"
              :label="$t('consultaFichero.label.propiosDescarga')"
              class="p-button-link"
              icon="pi pi-download"
            />
          </div>
          <div class="p-col-12 buttonContainer">
            <Button
              @click="consultarImpagos()"
              :label="$t('consultaFichero.button.propios')"
              class="bigBlueButton"
              icon="pi pi-caret-right"
              iconPos="right"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="p-lg-2 p-sm-12" />
  </div>
</template>

<script>
import DownloadsMixin from "@/utils/downloads";

export default {
  name: "FormularioDatosPropios",
  mixins: [DownloadsMixin],
  props: {},
  data() {
    return {};
  },
  methods: {
    consultarImpagos() {
      window.location.replace(
        "https://derechos.iciredimpagados.com/hc/es-es/articles/360020674620"
      );
    },
    downloadPDF() {
      this.downloadFromUri(
        "modelo.pdf",
        window.location.origin + "/assets/pdf/Formulario-acceso_1550835466.pdf"
      );
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.buttonContainer {
  display: flex;
  align-items: center;
  justify-content: center;

  .bigBlueButton {
    width: 10rem;
  }
}
</style>